/**
 * DEX deep-links with Blinkr's referral programs.
 *
 * Once a token graduates off the bonding curve it trades on a DEX. The
 * Mini App offers two destinations from the Token detail page:
 *   - STON.fi  — referral params (V2) credit Blinkr's referral address
 *     with a 1% cut (STON.fi V2's maximum).
 *   - OKX Web3 — referral via the `ref` query param (CC-040).
 *
 * CC-040: this file was `lib/stonfi.ts`; renamed to `lib/dex.ts` when
 * the OKX destination was added.
 */

/** Blinkr's STON.fi V2 referral wallet. */
export const STONFI_REFERRAL_ADDR =
  'UQAy9M0k3azm-1dqajatwKLzrtAUIqmZFmIq-OpekOUEhoCY';

/** Referral cut, percent — 1.0 is the STON.fi V2 maximum. */
export const STONFI_REFERRAL_PERCENT = '1.0';

/**
 * Build a STON.fi swap URL: TON → the given jetton master, pre-filled
 * with Blinkr's referral params.
 */
export function stonfiSwapUrl(masterAddr: string): string {
  const params = new URLSearchParams({
    ft: 'TON',
    tt: masterAddr,
    referral_address: STONFI_REFERRAL_ADDR,
    referral_percent: STONFI_REFERRAL_PERCENT,
  });
  return `https://app.ston.fi/swap?${params.toString()}`;
}

/** CC-040 — Blinkr's OKX referral code. */
export const OKX_REFERRAL_CODE = 'BLINKR';

/**
 * Build an OKX Web3 token page URL for the given jetton master, tagged
 * with Blinkr's referral code.
 */
export function okxTokenUrl(masterAddr: string): string {
  const params = new URLSearchParams({ ref: OKX_REFERRAL_CODE });
  return `https://web3.okx.com/token/ton/${masterAddr}?${params.toString()}`;
}
